var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgConnector7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.5,42.6A21.42,21.42,0,0,1,28.22,5.13l.43-.39.76-.15H56.19l.44.4A21.43,21.43,0,0,1,42.5,42.6Zm-12-33.75a17.24,17.24,0,1,0,24.05,0Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5,24.72a3.41,3.41,0,1,1,3.41-3.41A3.41,3.41,0,0,1,42.5,24.72Zm0-5.61a2.2,2.2,0,1,0,2.19,2.2A2.21,2.21,0,0,0,42.5,19.11Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,24.94a3.64,3.64,0,1,1,3.64-3.63A3.64,3.64,0,0,1,32,24.94Zm0-6.06a2.43,2.43,0,1,0,2.43,2.43A2.43,2.43,0,0,0,32,18.88Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.39,33.79A3.64,3.64,0,1,1,41,30.15,3.64,3.64,0,0,1,37.39,33.79Zm0-6.06a2.42,2.42,0,1,0,2.42,2.42A2.43,2.43,0,0,0,37.39,27.73Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.28,33.79a3.64,3.64,0,1,1,3.63-3.64A3.64,3.64,0,0,1,48.28,33.79Zm0-6.06a2.42,2.42,0,1,0,2.42,2.42A2.43,2.43,0,0,0,48.28,27.73Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.23,24.94a3.64,3.64,0,1,1,3.63-3.63A3.64,3.64,0,0,1,53.23,24.94Zm0-6.06a2.43,2.43,0,1,0,2.42,2.43A2.43,2.43,0,0,0,53.23,18.88Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.67,16.19A2.29,2.29,0,1,1,40,13.9,2.28,2.28,0,0,1,37.67,16.19Zm0-3.36a1.08,1.08,0,1,0,1.08,1.07A1.07,1.07,0,0,0,37.67,12.83Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.28,16.19a2.29,2.29,0,1,1,2.29-2.29A2.29,2.29,0,0,1,48.28,16.19Zm0-3.36a1.08,1.08,0,1,0,1.07,1.07A1.07,1.07,0,0,0,48.28,12.83Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.12,59.41a10,10,0,0,1-5.24-1.36A6.22,6.22,0,0,1,27,51.54c.95-3.39.79-5.78-.41-7.11A5.37,5.37,0,0,0,23,43H2.29a2.06,2.06,0,1,1,0-4.1H22.9a10.17,10.17,0,0,1,7.23,3c2.16,2.41,2.63,5.93,1.34,10.45a2.22,2.22,0,0,0,1,2.39,6.32,6.32,0,0,0,5.51,0A3.09,3.09,0,0,0,40.11,52V41.47a2.31,2.31,0,0,1,4.58,0V52c0,2.7-1.66,5-4.56,6.36A12.08,12.08,0,0,1,35.12,59.41Z",
    fill: "#231f20"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgConnector7);
export default __webpack_public_path__ + "static/media/img_connector_7.f262b237db91f153eccdd9f2c6c0689c.svg";
export { ForwardRef as ReactComponent };